import React from 'react';
import WarningIcon from 'assets/images/warning.svg';
import {getCurrencySymbol, toCurrency, titleCase, getNextBillingDate, planMap} from 'utils/helpers';

const SubscriptionSummary = ({paymentData}) => {
    const curr = getCurrencySymbol(paymentData?.metadata?.plan?.currency);
    const title = `${titleCase(paymentData?.metadata?.plan?.name)} 
    (${curr}${paymentData?.amount})`;
    const planAmount = `${curr} ${toCurrency(paymentData?.metadata?.plan?.amount)}`;
    const discount = `${curr} ${toCurrency(
        paymentData?.couponAmount ? paymentData?.couponAmount : 0
    )}`;
    const total = `${curr} ${toCurrency(
        paymentData?.metadata?.plan?.amount - paymentData?.couponAmount
    )}`;
    const billingDate = getNextBillingDate(paymentData?.metadata?.plan?.interval);
    const plan = planMap[paymentData?.metadata?.plan?.interval];

    return (
        <div className="left-content">
            <h1 className="head-1 sub-summary">Subscription Summary</h1>
            <div className="description">
                <h2 className="head-2">{title}</h2>
                <p className="description">{paymentData?.description}</p>
            </div>
            <div className="summary-section">
                <h3 className="title">Summary</h3>
                <div className="summary-details">
                    <p className="flex__between">
                        <span>{plan}</span> <span className="amount">{planAmount}</span>
                    </p>
                    <p className="flex__between">
                        <span>Discount</span> <span className="discount">- {discount}</span>
                    </p>
                </div>
                <div className="billing-section">
                    <p className="flex__between">
                        <span>Total Billed</span> <span className="total">{total}</span>
                    </p>
                    {paymentData?.metadata?.plan?.subscription_type === 'recurring' && (
                        <div className="warning">
                            <img src={WarningIcon} alt={'icon'} />
                            Next billing date {billingDate}
                        </div>
                    )}
                </div>
            </div>
            {(paymentData?.support_email || paymentData?.support_phone_number) && (
                <div className="info">
                    <p>For more information and inquireries:</p>
                    <div className="contact">
                        <p className="mb-1">{paymentData?.support_email}</p>
                        <p>{paymentData?.support_phone_number}</p>
                    </div>
                </div>
            )}
        </div>
    );
};

export default SubscriptionSummary;
